






























import { Component, Vue, Watch, Provide } from 'vue-property-decorator';
import Permission from "./component/PermissionV2.vue";
import { authorClient } from "@/api/index";
//import { CommonReq} from "@/pbjs/xcommon/module_pb";
import { GetPermSummaryByUserGroupReq, GetMenuTreeByRoleReq, GetDataPermTreeByUserGroupReq } from "@/pbjs/external/auth/auth_pb";
import { DataPermKind } from "@/pbjs/xcommon/enum_pb";
import { setCommon, errorMsg } from "@/utils/request";

@Component({
    name: 'system',
    components: {Permission}
})
export default class UserManagement extends Vue {
    @Provide() private placeMessage:string = "Automatic outgoing call record";
    @Provide() private filterText:string = "";
    @Provide() private activeName: string = "per";
    @Provide() private checkData: number[] = [1,2];
    @Provide() private token: string | null = "";
    @Provide() private roleGroupData:any = [];
    @Provide() private oldSelectedNodesArray: any = [];
    @Provide() private oldSelectedDataTree: any = [];
    @Provide() private permissionData: any[] = [];
    @Provide() private dataTree: any[] = [];
    @Provide() private roleid: any;
    @Provide() private isShowPermission: boolean = false;
    @Provide() private isShowDataTree: boolean = false;
    @Provide() private isShowCommit: boolean = false;
    @Provide() private defaultProps: any = {
        children: 'kidsList',
        label: 'name',
        id: 'id'
    }
    // @Provide() private groupDataTree

    @Watch("filterText")
    onFilterTextChanged(val: string) {
        const ref: any = this.$refs.tree;
        ref.filter(val);
    }

    @Watch("activeName")
    onActiveNameChanged(val: string) {
        if (this.roleid) {
            if (val === "per") {
                this.getPermSummaryByUserGroup(this.roleid);
            } else if (val === "data" || this.activeName === "groupdata") {
                this.getDataPermTreeByUserGroup(this.roleid);
            }
        }
    }

    private created() {
        this.token = localStorage.getItem("token");
        this.getUserGroupTree();
    }

    private filterNode(value: string, data: any) {
        if (!value) return true;
        return data.name.indexOf(value) !== -1;
    }

    private handleRoleIdentityClick(data: any) {
        if (data.id) {
            this.roleid = data.id;
            if (this.activeName === "per") {
                this.getPermSummaryByUserGroup(this.roleid);
            } else if (this.activeName === "data" || this.activeName === "groupdata") {
                this.getDataPermTreeByUserGroup(this.roleid);
            }
        }
    }

    private addPropertyEdit(data: any) {
        data.forEach((item: any) => {
            item.edit = false;
            item.label = item.rolename;
            item.id = item.roleid;
            item.children = item.kidrolesList;
            if (item.kidrolesList) {
                this.addPropertyEdit(item.kidrolesList);
            }
        });
        return data;
    }

    private refreshData() {
        this.getDataPermTreeByUserGroup(this.roleid);
    }

    private getPermSummaryByUserGroup(roleId: any) {
        let request:any = new GetMenuTreeByRoleReq();
        request.setCommonin(setCommon());
        request.setRoleid(roleId);
        authorClient.getPermSummaryByUserGroup(request, {}, (err: any, response:any) => {
            if(response) {
                let data:any = response.toObject();
                    this.permissionData = data.treeList;
                    this.oldSelectedNodesArray = [];
                    this.findSelectedNodes(this.permissionData);
                    this.isShowPermission = true;
            }
            if(err){errorMsg(err);};
        });
    }

    private findSelectedNodes(data: any) {
        data.forEach((item: any) => {
            if (this.activeName === "per") {
                item.disabled = true;
            }
            if (item.mark == 1) {
                if (this.activeName === "per" && item.kidsList.length == 0) {
                    this.oldSelectedNodesArray.push(item.id);
                } else if (this.activeName === "data" || this.activeName === "groupdata") {
                    this.oldSelectedDataTree.push(item.id);
                }
            }
            if(item.kidsList) {
                this.findSelectedNodes(item.kidsList);
            }
        });
    }

    private getDataPermTreeByUserGroup(roleId: any) {
        let request:any = new GetDataPermTreeByUserGroupReq();
        request.setCommonin(setCommon());
        request.setUsergroupid(roleId);
        if (this.activeName === "data") {
            // request.setKind(GetDataPermTreeByUserGroupReq.DataPermKind.DATA_PERM_KIND_PERSONAL);
            request.setKind(DataPermKind.DATA_PERM_KIND_PERSONAL);
        } else if (this.activeName === "groupdata") {
            // request.setKind(GetDataPermTreeByUserGroupReq.DataPermKind.DATA_PERM_KIND_GROUP);
            request.setKind(DataPermKind.DATA_PERM_KIND_GROUP);
        }
        authorClient.getDataPermTreeByUserGroup(request, {}, (err: any, response:any) => {
            if(response) {
                let data:any = response.toObject();
                if (!data.commonout || (data.commonout.code == 0)) {
                    if (this.activeName === "data") {
                        this.dataTree = data.datapermtreeList;
                        this.oldSelectedDataTree = [];
                        if (data.unassignedticketpermsList && data.unassignedticketpermsList.length > 0) {
                            data.unassignedticketpermsList.forEach((item: any, index: number) => {
                                data.unassignedticketpermsList[index].ticket = true;
                            })
                            this.dataTree = [...this.dataTree, ...data.unassignedticketpermsList];
                        }
                        this.findSelectedNodes(this.dataTree);
                        this.isShowDataTree = true;
                    } else if (this.activeName === "groupdata") {
                        this.oldSelectedDataTree = [];
                        this.dataTree = data.datapermtreeList;
                        this.findSelectedNodes(this.dataTree);
                        this.isShowDataTree = true;
                    }
                }
            }
            if(err){errorMsg(err);};
        });
    }

    private getUserGroupTree() {
        let request:any = setCommon();
        authorClient.getUserGroupTree(request, {}, (err: any, response:any) => {
            if(response) {
                let data:any = response.toObject();
                if (!data.commonout || (data.commonout.code == 0)) {
                    this.roleGroupData = data.treeList;
                } else {
                    this.$message.error(data.commonout.errmsg);
                }
            }
            if(err){errorMsg(err);};
        });
    }

 }
